import { memo } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, Marker } from "react-leaflet";
import DataExplorerMap from "./DataExplorerMap";
import MarkerClusterGroup from "react-leaflet-cluster";
import "./dataExplorer.css";

const ExplorerMapContainer = memo(({setSelectedProjects, setOpenList, filteredProjects, listRef}) => {
  /**
   * Will set the selectedProjects state to the projects (cluster) that were clicked then opens the projects list.
   */
  const clusterClick = (e) => {
    const cluster = e.layer;

    // Retrieve the markers in the cluster
    const markers = cluster.getAllChildMarkers();
    const selectedProjects = []

    // Get all of the selected projects from the indexes stored in the markers.
    markers.map((marker) => {
      selectedProjects.push(filteredProjects.filter(project => project.id == marker.options["data-key"] || project.id == parseInt(marker.options["data-key"]))[0]);
    })

    // Set the selected projects and open the list.
    setSelectedProjects(selectedProjects);
    setOpenList(true);

    listRef.current.scroll({top: 0});
  }

  /**
   * Will set the selectedProjects state to the project (marker) that was clicked then opens the projects list.
   */
  const markerClick = (e) => {
    // Set the selected project and open the list.
    setSelectedProjects(filteredProjects.filter(project => project.id == e.target.options["data-key"] || project.id == parseInt(e.target.options["data-key"])));
    setOpenList(true);
    listRef.current.scroll({top: 0});
  }

  /**
   * Creates the div icons for marker cluster layers.
   * @param {*} cluster The cluster layer.
   * @returns The div icon. 
   */
  const iconCreateFunction = (cluster) => {
    // Retrieve the amount of markers within the cluster.
    var childCount = cluster.getChildCount();

    // Determine the correct css class based on the amount of markers. 
		var c = ' marker-cluster-';
		if (childCount <= 5) {
			c += 'small';
		} else if (childCount <= 15) {
			c += 'medium';
		} else {
			c += 'large';
		}

    // Create and return the div icon.
		return new L.divIcon({ html: '<div><span class="text-white">' + childCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
  }

  return(
    <MapContainer
      center={[59.116864, -105.059681]}
      zoom={3}
      minZoom={3}
      maxZoom={18}
      style={{ height: "100%", zIndex: 0 }}
      worldCopyJump={true}
      maxBoundsViscosity={1}
    >
      <DataExplorerMap/>
      <MarkerClusterGroup
        removeOutsideVisibleBounds={false}
        iconCreateFunction={iconCreateFunction}
        zoomToBoundsOnClick={false}
        showCoverageOnHover={false}
        maxClusterRadius={50}
        singleMarkerMode={true}
        spiderfyOnMaxZoom={false}
        eventHandlers={{
          clusterclick: clusterClick
        }}
      >
        {filteredProjects.map((project, i) => {
          if(JSON.parse(project.centerPoint)){
            return(
              <Marker 
                position={JSON.parse(project.centerPoint)} 
                key={project.id || project.PK} 
                data-key={project.id || project.PK}
                eventHandlers={{
                  click: markerClick
                }}
              />
            )
          }
        })}
      </MarkerClusterGroup>
      {/* Render markers on right side of antimeridian */}
      <MarkerClusterGroup
        removeOutsideVisibleBounds={false}
        iconCreateFunction={iconCreateFunction}
        zoomToBoundsOnClick={false}
        showCoverageOnHover={false}
        maxClusterRadius={50}
        singleMarkerMode={true}
        spiderfyOnMaxZoom={false}
        eventHandlers={{
          clusterclick: clusterClick
        }}
      >
        {filteredProjects.map((project, i) => {
          if(JSON.parse(project.centerPoint)){
            return(
              <Marker 
                position={[JSON.parse(project.centerPoint)[0], JSON.parse(project.centerPoint)[1] + 360]} 
                key={project.id || project.PK}
                data-key={project.id || project.PK}
                eventHandlers={{
                  click: markerClick
                }}
              />
            )
          }
        })}
      </MarkerClusterGroup>
      {/* Render markers on left side of antimeridian */}
      <MarkerClusterGroup
        removeOutsideVisibleBounds={false}
        iconCreateFunction={iconCreateFunction}
        zoomToBoundsOnClick={false}
        showCoverageOnHover={false}
        maxClusterRadius={50}
        singleMarkerMode={true}
        spiderfyOnMaxZoom={false}
        eventHandlers={{
          clusterclick: clusterClick
        }}
      >
        {filteredProjects.map((project, i) => {
          if(JSON.parse(project.centerPoint)){
            return(
              <Marker 
                position={[JSON.parse(project.centerPoint)[0], JSON.parse(project.centerPoint)[1] - 360]} 
                key={project.id || project.PK} 
                data-key={project.id || project.PK}
                eventHandlers={{
                  click: markerClick
                }}
              />
            )
          }
        })}
      </MarkerClusterGroup>
    </MapContainer>
  );
})

export default ExplorerMapContainer